module.exports = __webpack_public_path__ + "img/no-header.14e63606.svg";